<script lang="ts">
import IssuesCell from '@/presentation/pages/resources/cells/IssuesCell.vue';

export default {
  name: 'IssuesColumn',
  components: { IssuesCell },
};
</script>

<template>
  <Column field="issues" style="width: 10rem">
    <template #header>
      {{ $t('glossary.issue', 2) }}
      <help-icon
        :title="$t('glossary.issue', 2)"
        :description="$t('features.issues.help_description')"
        link="https://support.sundata.nl/nl/articles/5422569-indicatoren-uitleg"
        class="ml-1"
      />
    </template>
    <template #body="slotProps">
      <issues-cell :issues="slotProps.data.plant.meter_issues" />
    </template>
  </Column>
</template>

<style scoped></style>
